// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__BqkE3","tab__active":"Tab_tab__active__LVnfV"};